import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { bootApp } from './app/boot';
import { registerServiceWorker } from './app/registerSw';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

bootApp().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  // Fire-and-forget. SW registration must not block the first paint, and
  // failures here should never crash the kid-facing app.
  void registerServiceWorker();
});
